import Vue from "vue";
import StatusIndicator from "vue-status-indicator";

Vue.use(StatusIndicator);
